(() => {
  const form = document.querySelector('[data-husband-towel-form]');
  const photo = document.querySelector('#HusbandTowelPhoto');
  const enlarge = document.querySelector('[data-husband-towel-enlarge]');

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-husband-towel-photo]');
    if (!button || !photo) return;
    photo.src = button.dataset.husbandTowelPhoto;
    photo.alt = button.querySelector('img').alt;
    if (enlarge) enlarge.href = button.dataset.husbandTowelPhoto;
    document.querySelectorAll('[data-husband-towel-photo]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
  });

  if (!form) return;
  const review = document.querySelector('[data-husband-towel-review]');
  const name = form.querySelector('[data-husband-name]');
  const validate = () => {
    name.setCustomValidity(name.value.trim() ? '' : 'Enter the name to embroider.');
  };
  for (const eventName of ['input', 'change']) form.addEventListener(eventName, () => { validate(); if (review) review.hidden = true; });
  form.addEventListener('submit', (event) => {
    validate();
    if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
    if (!form.hasAttribute('data-preview-husband-towel')) return;
    event.preventDefault();
    review.replaceChildren();
    const data = new FormData(form);
    const add = (tag, text) => { const element = document.createElement(tag); element.textContent = text; review.append(element); };
    add('h2', 'Your personalized name golf towel');
    for (const [key, value] of data) {
      if (key === 'properties[Personalization confirmed]' || !String(value).trim()) continue;
      add('p', `${key.replace(/^properties\[/, '').replace(/\]$/, '')}: ${String(value).trim()}`);
    }
    add('p', `Item subtotal: $${(23.99 * Number(data.get('quantity'))).toFixed(2)} USD`);
    add('p', 'Preview only — nothing has been ordered or saved. Shipping and taxes are not included.');
    review.hidden = false;
    review.focus();
  });
})();
